import React, { useContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import GlobalContext from "../Hooks/globalContext";

import Admin from "../Routes/Admin";
import Main from "../Routes/Main";
import Auth from "../Routes/Auth";

import Config from "../Routes/Config";
import Send from "../Routes/Send";
import History from "../Routes/History";
import Staking from "../Routes/Staking";
import Market from "../Routes/Market";
import MarketDetail from "../Routes/Market/Detail";
import MarketBuy from "../Routes/Market/Buy";
import MarketHistory from "../Routes/Market/History";
import Language from "../Routes/Config/Language";

import OTPRegister from "../Components/PinCodeOTP/Register";
import OTPReset from "../Routes/OTP/Reset";

const LoginRoutes = () => {
  return (
    <>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route exact path="/config" component={Config} />
        <Route exact path="/config/language" component={Language} />
        <Route exact path="/otp/reset" component={OTPReset} />
        <Route exact path="/otp/register" component={OTPRegister} />
        <Route exact path="/send" component={Send} />
        <Route exact path="/history" component={History} />
        <Route exact path="/staking" component={Staking} />
        <Route exact path="/market" component={Market} />
        <Route exact path="/market/history" component={MarketHistory} />
        <Route exact path="/market/:productId" component={MarketDetail} />
        <Route exact path="/market/order/:productId" component={MarketBuy} />
        <Route exact path="/admin" component={Admin} />

        <Redirect from="*" to="/" />
      </Switch>
    </>
  );
};

const LogoutRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" render={(props) => <Auth {...props} page="login" />} />
      <Route exact path="/login/verify" render={(props) => <Auth {...props} page="login/verify" />} />
      <Route exact path="/register/wallet" render={(props) => <Auth {...props} page="wallet" />} />
      <Route exact path="/register" render={(props) => <Auth {...props} page="register" />} />
      <Route exact path="/register/:recommend" render={(props) => <Auth {...props} page="register" />} />
      <Route exact path="/password/forgot" render={(props) => <Auth {...props} page="forgot" />} />
      <Route exact path="/password/verify" render={(props) => <Auth {...props} page="verify" />} />
      <Redirect from="*" to="/" />
    </Switch>
  );
};

const AppRouter = () => {
  const { isLogin } = useContext(GlobalContext);
  return isLogin.state ? <LoginRoutes /> : <LogoutRoutes />;
};

export default AppRouter;
